export default __webpack_public_path__ + "static/media/letalk-logo.199a9251.svg";